module.exports = require("vuetify/lib/components/VList");